// This is a manifest file that'll be compiled into bootstrap_sb_admin_base_v2.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or vendor/assets/javascripts of plugins, if any, can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file.
//
// Read Sprockets README (https://github.com/sstephenson/sprockets#sprockets-directives) for details
// about supported directives.
//
//= require_tree ./flot
//= require ./jquery/jquery.dataTables.min
//= require ./bootstrap/bootstrap.min
//= require ./bootstrap/dataTables.bootstrap.min
//= require ./metis_menu/metisMenu.min
//= require ./morris/morris.min
//= require ./raphael/raphael
//= require ./sb-admin-2/sb-admin-2

import jQuery from 'jquery';
import './flot/excanvas.min';
import './flot/jquery.flot';
import './flot/jquery.flot.pie';
// import './flot/jquery.flot.resize';
import './flot/jquery.flot.time';
import './flot/jquery.flot.tooltip.min';
import DataTables from './jquery/jquery.dataTables.min';
import Bootstrap from './bootstrap/bootstrap.min';
import DataTablesBootstrap from './bootstrap/dataTables.bootstrap.min';
import MetisMenu from './metis_menu/metisMenu.min';
import Morris from './morris/morris.min';
import Raphael from './raphael/raphael';
import SbAdmin2 from './sb-admin-2/sb-admin-2';